import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.m.css";
import { Link } from "@quintype/components";
import { get } from "lodash";

const LastestNewsSec = ({ className = "", collection }) => {
  const collections = get(collection, ["collection", "items"], []);
  let arr = [];
  collections.slice(0, 8).map(late => {
    const name = get(late, ["story", "sections", 0, "name"], null);
    const sectionUrl = get(late, ["story", "sections", 0, "section-url"], null);
    if (name) {
      arr.push({ name: name, url: sectionUrl });
    }
  });
  const key = "name";
  const arrayUniqueByKey = [...new Map(arr.map(item => [item[key], item])).values()];
  return (
    <div>
      <h5 className={styles["footer-title"]}>
        <span>LIVE TAMIL NEWS</span>
      </h5>
      <div className={styles["ul-grid"]}>
        <ul className={styles["latest-list"]}>
          {arrayUniqueByKey.map(late => (
            <li key={late.id} className={styles["li-list"]}>
              <Link href={`${late.url}`} className={styles["section-list"]}>
                {late.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

LastestNewsSec.propTypes = {
  className: PropTypes.string,
  collection: PropTypes.shape()
};

export default LastestNewsSec;
